module.exports = __webpack_public_path__ + "img/bg.57947545.jpg";